"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedCovenantLoanTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Gen Covenant Loan Tape`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            creditFacilitySlug: 'creditFacilitySlug',
            generatedFilterField: 'generated_filter_field',
            generatedFilterValue: 'generated_filter_value',
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    return (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => uiNode.nodeType === 'file_generatedLoanTape',
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 0,
        maxOutputs: 100, // there could be many outputs to tapes.
    });
};
// validate given IntermediateRecord.
// this is called after initial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ graph, tape, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'generatedCovenantLoanTape', `node is not a generatedCovenantLoanTape, found: [tape.type:${tape.type}]`);
    // validate that the input node has the expected tape definition,
    // and matches the configuration for the current node.
    const inputIds = (0, utils_1.getInputTapeIds)({ tapeId: tape.id, graph });
    (0, common_1.finleyAssert)(inputIds.length === 1, 'expected 1 input to generatedCovenantLoanTape');
    const inputArtifactId = inputIds[0];
    const inputArtifact = (0, utils_1.getTapeById)({ tapeId: inputArtifactId, graph });
    (0, common_1.finleyAssert)(inputArtifact, `could not find input artifact [id:${inputArtifactId}]`);
    const { creditFacilitySlug: inputArtifactCreditFacilitySlug } = inputArtifact;
    const { artifactSlug, creditFacilitySlug, configuration: { generatedFilterField }, } = tape;
    const configErrors = [];
    // check creditFacilitySlug value.
    if (inputArtifactCreditFacilitySlug &&
        inputArtifactCreditFacilitySlug !== creditFacilitySlug) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] has mismatched [creditFacilitySlug:${creditFacilitySlug}] with parent [inputArtifactCreditFacilitySlug:${inputArtifactCreditFacilitySlug}]`);
    }
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(inputArtifactId);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, 'covenant loan tape has parent node with invalid tapeDefinition');
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, 'validateIntermediateTape: covenant loan tape has parent node with null tapeDefinition');
    const { baseFields } = tapeDefinitionResult.data;
    // ensure that tape has the generatedFilterField if configured
    if (generatedFilterField) {
        const baseField = baseFields.find(({ field }) => field === generatedFilterField);
        if (!baseField) {
            configErrors.push(`validateIntermediateTape: [${artifactSlug}] does not have [generatedFilterField:${generatedFilterField}]`);
        }
    }
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_generatedCovenantLoanTape = {
    // what should node say on the tape-builder node creation menu.
    nodeTypeText: 'Covenant Loan Tape',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    // operation nodes dont render badges.
    badgeTexts: ['Generated', 'CovenantTape'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map